module.exports = __webpack_public_path__ + "img/42.dbf10074.jpg";